import { render, staticRenderFns } from "./WebsiteContentBlock.vue?vue&type=template&id=3c8a1f86&lang=pug&"
import script from "./WebsiteContentBlock.vue?vue&type=script&lang=ts&"
export * from "./WebsiteContentBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports